// extracted by mini-css-extract-plugin
export default {"callButton":"call_callButton__d9zHq","icon":"call_icon__eWDtY"};